import { FiniteStateMachine } from './../../../model/FiniteStateMachine';
import { AfterContentInit, Component, OnInit, ViewChild, AfterViewInit, EventEmitter, Input, ChangeDetectorRef, Output } from '@angular/core';
import { ViewStackComponent } from '../../view-stack/view-stack.component';
import { SnapActions } from 'src/app/model/map-actions/snap-actions';
import { SnapLayer } from 'src/app/model/virutal-layers/snap-layer';
import { DrawInteractionModes, DrawMode, DrawPaneComponent } from '../../draw-pane/draw-pane.component';
import { Dict } from 'src/app/types/decorable';
import { SLLayer } from 'src/app/model/sl-layer';
import { PixoSpatialCoord } from 'src/app/model/Pixospatial';
import { SelectionProxy } from 'src/app/model/selection-proxy';
import * as turf from '@turf/turf';
import * as math from 'mathjs';
import { Vector, GetNearestPointOnInfiniteLine } from 'src/app/model/drawing/vector-utils';
import { ROICorners } from '../../draw-pane/rectangle-roi';
@Component({
  selector: 'app-snap-tools',
  templateUrl: './snap-tools.component.html',
  styleUrls: ['./snap-tools.component.scss']
})
export class SnapToolsComponent implements AfterViewInit {

  @ViewChild('snapViews') snapViews: ViewStackComponent;

  private _currentVertex?: any
  @Input()
  public set currentVertex(v: any) {
    this._currentVertex = v;
  }
  public get currentVertex(): any {
    return this._currentVertex;
  }

  private _currentSegment?: any;
  @Input()
  set currentSegment(v: any) {
    this._currentSegment = v;
  }
  get currentSegment(): any {
    return this._currentSegment;
  }

  @Input()
  public currentSnapPt?;
  @Input()
  public currentSnapSeg?;
  public isLine?: boolean = false;
  public isPoint?: boolean = false;
  public direction: 'to' | 'from' = 'from';
  public noState = true;
  public noMergeState = true;
  public moving = false;
  public addingAt = false;
  public movingPerp = false;
  public addingPerp = false;
  public merging = false;
  public ROIing = false;
  public selsAdding = false;
  public selsDeling = false;
  public selsGrpAdding = false;
  public selsGrpDeling = false;
  public updated = true;
  private drawPane?: DrawPaneComponent;
  private _geomType: string;
  public fsm: FiniteStateMachine = new FiniteStateMachine(this, [
    'noState',
    'moving:move-sel-to-snap',
    'addingAt:add-at-snap',
    'movingPerp:move-to-perp',
    'addingPerp:add-at-perp',
    'merging:merge-snaps']);
  public mergeModes: FiniteStateMachine = new FiniteStateMachine(this, [
    'noMergeState',
    'selsAdding:sels-add',
    'selsDeling:sels-del',
    'selsGrpAdding:sels-grp-add',
    'selsGrpDeling:sels-grp-del']);
  public fsmChange = new EventEmitter<FiniteStateMachine>();

  public get hasOneDrawnPoint(): boolean {
    return this.drawPane?.GetSelectedFeature()?.points?.length >= 1;
  }
  public get isGeometryFriendly(): boolean {
    if (this.drawPane?.GetSelectedFeature()?.type === 'point') {
      return !this.hasOneDrawnPoint;
    }
    return true;
  }
  public get isPolyVertexGeom(): boolean {
    if (this.drawPane?.GetSelectedFeature()?.type === 'point') return false;
    return true;
  }
  private _snapLayer: SLLayer;
  @Input()
  public set snapLayer(layer: SLLayer) {
    this._snapLayer = layer;
    this.Update();
  }
  public get snapLayer(): SLLayer {
    return this._snapLayer;
  }

  private _drawPaneChanges?: SelectionProxy;
  @Input()
  set drawPaneChanges(changes: SelectionProxy) {
    if (!!this._drawPaneChanges) return;
    if (!changes) return;
    this._drawPaneChanges = changes;
    this._drawPaneChanges.RegisterListener('snap-tools', (params) => {
      if (params.properties.indexOf('snapGeomChange')) {
        const geometryLoad = this._drawPaneChanges.GetProperty('snapGeomChange')
        if (geometryLoad && !this.drawPane?.GetSnaps()?.points?.points?.length) {
          this.snapViews.SetView('no-snap-layer');
        } else if (this.snapViews.currentView.viewName === 'no-snap-layer') {
          this.Reset();
        }
      }
      this.UpdateSelections();
    })
  }

  @Output()
  toolChange = new EventEmitter<string>();

  private _mergeMode: string;

  public get fromPoint(): boolean {
    return this.direction === 'from';
  }
  public get toPoint(): boolean {
    return this.direction === 'to';
  }
  public currentState: string = 'noState';
  public get requiredDrawMode(): DrawMode {
    if (this.moving) return 'snap';
    if (this.addingAt) return 'snap';
    if (this.addingPerp) return 'snap';
    if (this.movingPerp) return 'snap';
    if (this.merging && this.selsGrpAdding) return 'roi';
    if (this.merging && this.selsGrpDeling) return 'roi';
    if (this.merging && this.selsDeling) return 'feature';
    if (this.merging) return 'feature';
    return '';
  }
  constructor(private cdr: ChangeDetectorRef) {

    SnapActions.RegisterComponent('snap-tools', this)
    this.fsm.RegisterHandlers(
      (params: any) => {
        this.currentState = params.value;
        this.toolChange.emit(this.currentState);
        if (!!params.isOn) {

          this.SetView(params.value);

        } else {
          this.SetView('noState');
        }
        this.ModeUpdate();
      },
      () => {
        this.SetView('noState');
        this.toolChange.emit('');
      },
      () => {
        // this.RefreshActions();
      }
    );
    this.mergeModes.RegisterHandlers(
      (params: any) => {
        if (!!params.isOn) this._mergeMode = params.value;
        this.MergeModeUpdate();
        this.cdr.detectChanges();

      },
      () => {
        this.mergeModes.SetState('noMergeState', true);
        if (!!this.drawPane) {
          this.drawPane.drawMode = this.requiredDrawMode;
        }
        this.cdr.detectChanges();

      }
    )


  }
  SetupDrawPane() {
    this.drawPane = this.snapLayer.map.component.drawPane;
  }
  Update() {
    if (!this.drawPane) {
      if (!this.snapLayer) return;
      this.SetupDrawPane();

    }

    this.ModeUpdate()
    this.updated = true
    this.cdr.detectChanges();
  }
  ngAfterViewInit(): void {
    this.SetView(this.currentState);
  }
  ToggleDirection() {
    this.direction = (this.direction === 'to') ? 'from' : 'to';
  }
  SetView(view: string) {
    if (!this.drawPane?.GetSnaps()?.points?.points?.length) {
      this.snapViews.SetView('no-snap-layer');
      return;
    }
    this.snapViews.SetView(view);
    // this.RefreshActions();
  }
  SetSnapTool(name: string, isOn: boolean) {

    this.fsm.SetState(this.fsm.GetValueState(name), isOn);
  }
  SetMergeMode(mode: string, isOn: boolean) {
    window.requestAnimationFrame(() => {

      this.mergeModes.SetState(this.mergeModes.GetValueState(mode), isOn);
      if (mode === 'sels-del') {
        this.currentVertex = undefined;
        this.drawPane?.GetSelectedFeature().Deselect();
        return;
      }
      if (mode === 'sels-grp-del') {
        this.currentVertex = undefined;
        this.drawPane?.GetSelectedFeature().Deselect();
        return;
      }

    });
    this.drawPane?.DeselectSnaps();

  }
  GetAction(toolName: string) {
    switch (toolName) {
      case 'move-sel-to-snap':
        return 'moving';
        break;
      case 'add-at-snap':
        return 'addingAt';
        break;
      case 'add-at-perp':
        return 'addingPerp';
        break;
      case 'move-to-perp':
        return 'movingPerp';
      case 'merge-snaps':
        return 'merging';
        break;
    }
  }
  UpdateSelections() {
    if (!!this._drawPaneChanges) {
      this._currentSegment = this._drawPaneChanges.GetProperty('segment');
      this._currentVertex = this._drawPaneChanges.GetProperty('vertex');
      this.currentSnapPt = this._drawPaneChanges.GetProperty('snapVertex');
      this.currentSnapSeg = this._drawPaneChanges.GetProperty('snapSegment');

      const entered = this._drawPaneChanges.GetProperty('entered');

      if (this.addingAt && !!entered) {
        const coord = entered.coord;
        window.requestAnimationFrame(() => {
          //this.drawPane?.HandleFeatureInteraction(coord);
          this.drawPane?.HandleFeatureInteraction(coord,()=>{},true);

          // this.drawPane?.AddVertexFromCoord(coord);
        })
      }
      if (this.moving && !!entered) {
        const coord = entered.coord;
        if (this.currentVertex) {
          window.requestAnimationFrame(() => {
            this.currentVertex.coord.UpdateFromCoord(entered.coord);
          });
        }
      }
      const enteredSeg = this._drawPaneChanges.GetProperty('enteredSeg');
      if (this.addingAt && !!enteredSeg) {
        window.requestAnimationFrame(() => {
          this.drawPane.HandleFeatureInteraction(enteredSeg.lastClick);
        });
      }
      if (this.addingPerp && !!enteredSeg) {
        window.requestAnimationFrame(() => {
          this.AddAtPerp(enteredSeg);
        })
      }
      if (this.movingPerp && !!enteredSeg) {
        window.requestAnimationFrame(() => {
          this.MoveToPerp(enteredSeg);
        })
      }

      if (!!this.currentVertex && this.moving && !!enteredSeg) {
        window.requestAnimationFrame(() => {
          this.currentVertex.coord.UpdateFromCoord(enteredSeg.lastClick);
        });
      }


    }
    if (this.noState) return;
    this.ModeUpdate();
  }
  ModeUpdate() {
    if (this._ignoreMode) return;
    if (!this.merging) {
      if (this.mergeModes.GetCurrentState() !== 'noMergeState') {
        this.mergeModes.SetState('noMergeState', true);
      }

    }
    switch (this.currentState) {
      case 'move-sel-to-snap':
        this.MoveSelToSnap();
        break;
      case 'add-at-snap':
        this.AddAtSnap();
        break;
      case 'move-to-perp':
        this.MoveToPerp();
        break;
      case 'add-at-perp':
        this.AddAtPerp();
        break;
    }
    if (this.merging) {
      const roiCorners = this._drawPaneChanges.GetProperty('ROICorners');
      const entered = this._drawPaneChanges.GetProperty('entered');

      switch (this.mergeModes.GetCurrentValue()) {
        case 'sels-del':
          this.DelSelVertex();
          break;
        case 'sels-grp-add':
          if (!!roiCorners && !entered) {
            this.MergeWithinROI(roiCorners);
          }
          break;
        case 'sels-grp-del':
          if (!!roiCorners && !entered) {
            this.RemoveWithinROI(roiCorners);
          }
      }
      this.MergeModeUpdate();
    }
    console.log(this.currentState)
  }
  MergeModeUpdate() {
    if (this.selsGrpAdding) {
      this.ROIing = true;
      this.drawPane.GetROI('rectangle');
    } else if (this.selsGrpDeling) {
      this.ROIing = true;
      this.drawPane.GetROI('rectangle');
    } else {
      this.ROIing = false;
    }
  }
  MoveSelToSnap() {
    if (!this.moving) return;
    if (!this.currentVertex) {
      if (!!this.currentSnapSeg && !!this.currentSnapSeg[0]) {
        this.drawPane.GetSnaps().segments.Deselect();
      }
      return;
    }
    if (!this.drawPane) return;
    this.drawPane.SnapOn('any');
    if (!(!!this.currentSnapPt || !!this.currentSnapSeg)) return;
    if (this.currentSnapPt?.length > 1) return;
    if (this.currentSnapSeg?.length > 1) return;
    if (this.currentSnapPt?.length + this.currentSnapSeg?.length === 0) return;
    this._ignoreMode = true;

    const isSnapSeg = this.currentSnapSeg?.length === 1;

    switch (isSnapSeg) {
      case true:
        {
          const snapCoord: PixoSpatialCoord = this.currentSnapSeg[0].lastClick;//  this.GetPerpCoord();
          const vertexCoord: PixoSpatialCoord = this.currentVertex.coord as PixoSpatialCoord;
          vertexCoord.UpdateSpatial(snapCoord.spatial.lng, snapCoord.spatial.lat);
          this.drawPane.GetSnaps().segments.Deselect();
        }
        break;
      case false:
        {
          const snapCoord: PixoSpatialCoord = this.currentSnapPt[0].coord as PixoSpatialCoord;
          const vertexCoord: PixoSpatialCoord = this.currentVertex.coord as PixoSpatialCoord;
          vertexCoord.UpdateSpatial(snapCoord.spatial.lng, snapCoord.spatial.lat);
          window.requestAnimationFrame(() => {
            this.drawPane.GetSnaps().points.Deselect();
          })
        }
        break;
    }
    this.currentVertex.updateUI()
   this.currentVertex.updateContext();
    this.currentVertex.clearAccuracy();

    this._drawPaneChanges.SetProperty('snapVertex', null);
    this._ignoreMode = false;

  }
  private _ignoreMode: boolean = false;
  AddAtSnap() {
    if (!this.addingAt) {
      return;
    }
    // if (!(!!this.currentVertex || !!this.currentSegment)) return;
    if (!this.drawPane) return;
    this.drawPane.SnapOn();
    const snapPt = this.currentSnapPt;
    const snapSeg = this.currentSnapSeg;
    if (!(!!snapPt || !!snapSeg)) return;
    if (snapPt?.length > 1) return;
    if (snapSeg?.length > 1) return;
    if (snapPt?.length + snapSeg?.length === 0) return;

    const isSnapSeg = snapSeg?.length === 1;
    const isSeg = !!this.currentSegment;
    this._ignoreMode = true;
    const snapSegSeg = isSnapSeg && isSeg;
    const snapPtSeg = !isSnapSeg && isSeg;
    const snapSegVertex = isSnapSeg && !isSeg;
    const snapPtVertex = !isSnapSeg && !isSeg;
    switch (isSnapSeg) {
      case true:
        {
          const snapCoord = isSeg ? this.GetSegCoordFromSegment() : this.currentSnapSeg[0].lastClick;//this.GetNearestCoord();
          if (snapCoord) {
            this.drawPane?.HandleFeatureInteraction(snapCoord,()=>{},true);
            // this.drawPane.AddVertexFromCoord(snapCoord);
          }
          window.requestAnimationFrame(() => {
            this.drawPane.DeselectSnaps();
          })
        }
        break;
      case false:
        {
          const snapCoord: PixoSpatialCoord = this.currentSnapPt[0].coord as PixoSpatialCoord;
          this._drawPaneChanges.SetProperty('snapVertex', null);
          //window.requestAnimationFrame(() => {

            // this.drawPane.TurnOn();
            this.drawPane?.HandleFeatureInteraction(snapCoord,()=>{},true);
            // this.drawPane.AddVertexFromCoord(snapCoord);
          //})
          window.requestAnimationFrame(() => {
            this.drawPane.DeselectSnaps();
          })

        }
    }
    this._ignoreMode = false;

  }
  MoveToPerp(seg?) {
    if (!this.currentVertex) return;
    if (this.currentSnapPt) {
      this.drawPane.GetSnaps().points.Deselect();
      return;
    }
    if(!seg && !this.currentSnapSeg?.length) return;

    const snapSeg = (!!seg) ? seg : this.currentSnapSeg[0];
    if (!snapSeg) return;
    this._ignoreMode = true;
    const coord = this.GetPerpCoord(seg);
    (this.currentVertex.coord as PixoSpatialCoord).UpdateFromCoord(coord);
    this.currentVertex.updateUI();
    this.drawPane.GetSnaps().segments.Deselect();
    this._ignoreMode = false;
  }
  AddAtPerp(seg?) {
    if (!this.currentVertex) return;
    if (this.currentSnapPt) {
      this.drawPane.GetSnaps().points.Deselect();
      return;
    }
    if(!seg && !this.currentSnapSeg?.length) return;
    const snapSeg = (!!seg) ? seg : this.currentSnapSeg[0];
    if (!snapSeg) return;
    this._ignoreMode = true;
    const coord = this.GetPerpCoord(seg);
    this.drawPane.HandleFeatureInteraction(coord);
    // this.drawPane.AddVertexFromCoord(coord);
    this.drawPane.GetSnaps().segments.Deselect();
    this._ignoreMode = false;
    if (!this.isPolyVertexGeom) this.Reset();
  }
  DelSelVertex() {
    if (!this.currentVertex) {
      if(this.currentSegment) {
        this.drawPane.GetSelectedFeature().Deselect();
      }
      return;
    }
    if (!this.selsDeling) return;
    this._ignoreMode = true;
    this.drawPane.DeleteVertex();

    this._ignoreMode = false;
    window.requestAnimationFrame(() => {
      this.drawPane.GetSelectedFeature().Deselect();
    })

  }
  GetSegCoordFromVertex(): null | any {
    if (!this.drawPane?.spatialContext) return;

    if (!this.currentVertex) return null;
    if (!this.currentSnapSeg) return null;
    const vertexLngLat = this.currentVertex.coord.spatial;
    const turfPoint = turf.point([vertexLngLat.lng, vertexLngLat.lat]);
    const fromLngLat = this.currentSnapSeg[0].from.spatial;
    const toLngLat = this.currentSnapSeg[0].to.spatial;
    const line = turf.lineString([[fromLngLat.lng, fromLngLat.lat], [toLngLat.lng, toLngLat.lat]])
    const nearestPt = turf.nearestPointOnLine(line, turfPoint, { units: 'kilometers' });
    const coord = nearestPt.geometry.coordinates
    const pixo = this.drawPane.spatialContext;
    const snapCoord = pixo.PixoSpatialCoord(pixo.SpatialCoord({ lng: coord[0], lat: coord[1] }));
    return snapCoord;
  }
  GetSegCoordFromSegment() {
    if (!this.currentSegment) return null;
    if (!this.currentSnapSeg) return null;

    const snapFrom = this.currentSnapSeg[0].from;
    const snapTo = this.currentSnapSeg[0].to;
    const segFrom = this.currentSegment.from.coord;
    const segTo = this.currentSegment.to.coord;
    const xsect = this.drawPane.spatialContext.CoordIntersect(snapFrom, snapTo, segFrom, segTo);
    return xsect;
  }
  GetNearestCoord(): PixoSpatialCoord {
    if (!!this.currentSnapSeg && !this.currentVertex) {
      const fromLngLat = this.currentSnapSeg[0].from.spatial;
      const toLngLat = this.currentSnapSeg[0].to.spatial;
      const line = turf.lineString([[fromLngLat.lng, fromLngLat.lat], [toLngLat.lng, toLngLat.lat]])
      const midPt = turf.center(line);
      const [lng, lat] = midPt.geometry.coordinates;
      const pixo = this.drawPane.spatialContext;
      const coord = pixo.PixoSpatialCoord(pixo.SpatialCoord({ lng: lng, lat: lat }));
      this.drawPane.HandleFeatureInteraction(coord);
      // this.drawPane.AddVertexFromCoord(coord);
      return;
    }
    if (!this.currentVertex) return null;
    if (!this.currentSnapSeg) return null;

    return this.drawPane.spatialContext.GetNearestCoord(
      this.currentSnapSeg[0].from,
      this.currentSnapSeg[0].to,
      this.currentVertex.coord
    );
  }
  GetPerpCoord(seg?): PixoSpatialCoord {
    const snapSeg = !!seg ? seg : this.currentSnapSeg[0];
    const from = snapSeg.from;
    const to = snapSeg.to;
    const vert = this.currentVertex.coord;
    return this.drawPane.spatialContext.GetNearestInfiniteCoord(from, to, vert);
  }
  MergeWithinROI(roi: ROICorners) {
    this.drawPane.selectionProxy.ToggleUpdating(false);
    this.drawPane.selectionProxy.SetProperty('ROICorners', undefined);
    this.drawPane.selectionProxy.ToggleUpdating(true);
    this.drawPane.ConfirmNewKnowledge(() => {

      const points = this.drawPane.GetSnaps().points.GetWithinROI(roi);
      if (this.currentVertex) {
        this.drawPane.spatialContext.SortByDistance(this.currentVertex.coord, points);
        for (const point of points) {
          this.drawPane.AddVertexFromCoord(point.coord);
        }

      }
      if (this.currentSegment) {
        this.drawPane.spatialContext.SortByDistance(this.currentSegment.from.coord, points);
        let seg = this.currentSegment;
        if (points.length <= 0) return;
        this._ignoreMode = true;
        for (const point of points) {
          const vertex = this.drawPane.AddVertexFromCoord(point.coord);
          if (vertex?.nextSeg()) {
            this.drawPane.GetSelectedFeature().Select(vertex.nextSeg().id);
          }
        }

        this._ignoreMode = false;

      }
      this.MergeModeUpdate();
    });
  }
  RemoveWithinROI(roiCorners: ROICorners) {
    this.drawPane.selectionProxy.ToggleUpdating(false);
    this.drawPane.selectionProxy.SetProperty('ROICorners', undefined);
    this.drawPane.selectionProxy.ToggleUpdating(true);
    const points = this.drawPane.GetSelectedFeature().GetWithinROI(roiCorners);
    //this._ignoreMode = true;
    for (const point of points) {
      this.drawPane.GetSelectedFeature().Select(point.id);
      this.drawPane.DeleteVertex();
    }
    //this._ignoreMode = true;

  }
  Reset() {
    if (this.drawPane?.GetSnaps().points.points.length > 0) {
      if (this.snapViews.currentView.viewName === 'no-snap-layer') {
        this.snapViews.SetView('noState');
      }
    }

    if (this.fsm.GetCurrentState() !== 'noState') {
      this.fsm.SetState('noState', true);

    }
    if (this.mergeModes.GetCurrentState() !== 'noMergeState') {
      this.mergeModes.SetState('noMergeState', true);
    }
  }
}
